import {all} from 'redux-saga/effects'
import {saga as app} from './modules/app'
import {saga as auth} from './modules/auth'
import {saga as actions} from './modules/actions'
import {saga as actionTypes} from './modules/actionTypes'
import {saga as equipment} from './modules/equipment'
import {saga as bodyAreas} from './modules/bodyAreas'
import {saga as users} from './modules/users'
import {saga as routines} from './modules/routines'
import {saga as activities} from './modules/activities'
import {saga as goals} from './modules/goals'

const saga = function* () {
  yield all([
    app(),
    auth(),
    actions(),
    actionTypes(),
    equipment(),
    bodyAreas(),
    users(),
    routines(),
    activities(),
    goals(),
  ])
}

export default saga
